import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { RestfullApiService } from "../../config/service";
import $ from "jquery"; // Import jQuery
import DOMPurify from "dompurify";

import { dateFormat } from "../../utils";
import { MEDIA_URL } from "../../config/url";
import { decryptData, encryptData } from "../../utils/storage";
import DefaultEventImg from "../../assets/img/masthead/default-event.png";
import PreLoader from "../../utils/PreLoader";
import toast from "react-hot-toast";
import {
  FacebookShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
} from "react-share";
import { Avatar, Modal } from "@mui/material";
import dayjs from "dayjs";

export default function EventDetails() {
  const [eventDetail, setEventDetail] = useState({});
  const [viewMoreDescription, setViewMoreDescription] = useState(false);
  const [viewMoreRefund, setViewMoreRefund] = useState(false);
  const [viewMoreRules, setViewMoreRules] = useState(false);
  const [eventTakeaway, setEventTakeaway] = useState([]);
  const [raceDayFacilities, setRaceDayFacilities] = useState([]);
  const [priceCategory, setPriceCategory] = useState([]);
  const [priceViewMore, setPriceViewMore] = useState(false);
  const [eligibility, setEligibility] = useState([]);
  const [eligibilityViewMore, setEligibilityViewMore] = useState(false);
  const [reviews, setReviews] = useState([]);
  const [bibDetails, setBibDetails] = useState([]);
  const [fetchingDetails, setFetchingDetails] = useState(false);
  const [healthSolution, setHealthSolution] = useState([]);
  const [showContact, setShowContact] = useState(false);
  const [mapImage, setMapImage] = useState();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { event_id } = useParams();
  const navigate = useNavigate();

  const [isRefundTrimmed, setIsRefundTrimmed] = useState(false);
  const [isRulesTrimmed, setIsRulesTrimmed] = useState(false);
  const [isDescriptionTrimmed, setIsDescriptionTrimmed] = useState(false);

  const refundRef = useRef(null);
  const rulesRef = useRef(null);
  const descriptionRef = useRef(null);

  const checkContentHeight = (ref, setTrimmedState) => {
    if (ref.current) {
      const lineHeight = parseInt(getComputedStyle(ref.current).lineHeight, 10);
      const maxHeight = lineHeight * 3; // 3 lines height
      if (ref.current.scrollHeight > maxHeight) {
        setTrimmedState(true);
      }
    }
  };

  useEffect(() => {
    checkContentHeight(refundRef, setIsRefundTrimmed);
  }, [eventDetail?.Refund_Cancellation]);

  useEffect(() => {
    checkContentHeight(rulesRef, setIsRulesTrimmed);
  }, [eventDetail?.Rules_Regulations]);

  useEffect(() => {
    checkContentHeight(descriptionRef, setIsDescriptionTrimmed);
  }, [eventDetail?.Event_Description]);

  const sanitizeAndModifyHTML = (html) => {
    // Create a new div element to parse the HTML string
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    // Modify the styles of all span elements
    const spans = tempDiv.querySelectorAll("span");
    spans.forEach((span) => {
      span.style.fontFamily = "Inter, sans-serif";
      span.style.color = "#535B62";
      // span.style.fontSize = "13px !important";
    });

    // Sanitize the modified HTML string
    return DOMPurify.sanitize(tempDiv.innerHTML);
  };
  const handlePageShareLink = async () => {
    try {
      const url = window.location.href;
      console.log(url);
      await navigator.clipboard.writeText(url);
      toast.success("Link copied to clipboard!");
    } catch (error) {
      toast.error("Failed to copy link.");
    }
  };

  async function loadEvent(Event_Id) {
    const reqdata = {
      Method_Name: "Getone",
      Month: "",
      Sport_Id: "",
      City_Id: "",
      Event_Id: Event_Id,
      SearchBy: "",
    };
    try {
      setFetchingDetails(true);
      const result = await RestfullApiService(
        reqdata,
        "participant/event_list"
      );
      if (result) {
        return result;
      }
    } catch (err) {
      alert(err);
    } finally {
      setFetchingDetails(false);
    }
  }
  const shareContent = async () => {
    const url = window.location.href;
    const message = `${url}`;
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Check out this awesome content!",
          text: message, // Full message including the URL
          // Omitting url property
        });
        console.log("Content shared successfully");
      } catch (error) {
        console.error("Error sharing content:", error);
      }
    } else {
      console.log("Share API not supported");
      // Optionally provide a fallback here
    }
  };

  useEffect(() => {
    // jQuery code to handle the click event and toggle detailsBox
    $(document).ready(function () {
      $(".cta-btn").click(function (e) {
        e.preventDefault();
        $("#detailsBox").slideToggle();
      });
    });

    async function fetchEventDetails() {
      const decrypted = decryptData(event_id);
      const response = await loadEvent(decrypted);

      if (response) {
        setEventDetail(response?.data?.Result?.Table1[0]);
        setEventTakeaway(response?.data?.Result?.Table2);
        setRaceDayFacilities(response?.data?.Result?.Table3);
        setPriceCategory(response?.data?.Result?.Table4);
        setEligibility(response?.data?.Result?.Table5);
        setReviews(response?.data?.Result?.Table6);
        setHealthSolution(response?.data?.Result?.Table7[0]);
        setBibDetails(response?.data?.Result?.Table8);
      }
    }

    if (event_id) {
      fetchEventDetails();
    }
  }, [event_id]);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      {/* <Helmet>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <title>{eventDetail?.Display_Name}</title>
        <meta name="title" key="title" content={eventDetail?.Display_Name} />
        <meta
          name="description"
          key="description"
          content={eventDetail?.Display_Name}
        />
        <meta
          property="og:title"
          key="og:title"
          content={eventDetail?.Display_Name}
        />
        <meta property="og:locale" key="og:locale" content="en_US" />
        <meta charSet="utf-8" />
        <meta property="og:type" key="og:type" content="website" />
        <meta
          property="og:image"
          key="og:image"
          content={`${MEDIA_URL}${eventDetail.Image_Path}`}
        />
      </Helmet> */}
      {/* <meta name="description" key="description" content={metaDescription} /> */}
      {/* <meta
        property="og:description"
        key="og:description"
        content={metaDescription}
      /> */}
      {/* <meta
          property="og:image"
          content={`${MEDIA_URL}${eventDetail.Image_Path}`}
          /> */}
      {/* <meta
          property="og:image"
          content="https://s3.ap-south-1.amazonaws.com/townscript-production/images/91dec85a-0c31-4fa4-8723-0f8b222a3f5c.jpg"
        />
        <meta property="og:url" content={window.location.href}></meta>
        <meta property="og:type" content="website" /> */}
      {fetchingDetails && <PreLoader />}
      {!fetchingDetails && (
        <>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div class="langMenu__content bg-white rounded-8">
              <div class="px-10 py-10 sm:px-15 sm:py-15">
                <button class="pointer absolute map-btn" onClick={handleClose}>
                  <i class="far fa-times-circle text-primary text-25"></i>
                </button>
                <img
                  alt="map"
                  class="rounded-8 w-full h-400 object-contain"
                  src={
                    mapImage
                      ? `${MEDIA_URL}/${mapImage}`
                      : `${MEDIA_URL}/img/comingsoon.png`
                  }
                />
              </div>
            </div>
          </Modal>
          <section
            style={{ marginTop: "90px" }}
            className="py-5 d-flex items-center bg-blue-1-05"
          >
            <div className="container">
              <div className="row y-gap-10 items-center justify-between">
                <div className="col-auto">
                  <div className="row x-gap-10 y-gap-5 items-center text-14 fw-500 text-light-1 font-inter">
                    <div className="col-auto">
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          navigate("/");
                          window.location.reload();
                        }}
                      >
                        Home
                      </div>
                    </div>
                    <div className="col-auto">
                      <div className="">{">"}</div>
                    </div>
                    <div className="col-auto">
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          navigate("/event/list");
                          window.location.reload();
                        }}
                      >
                        Events
                      </div>
                    </div>
                    <div className="col-auto">
                      <div className="">{">"}</div>
                    </div>
                    <div className="col-auto">
                      <div className="text-primary cursor-pointer">
                        {eventDetail?.Display_Name}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="singleMenu js-singleMenu">
            <div className="singleMenu__content">
              <div className="container">
                <div className="row y-gap-20 justify-between items-center">
                  <div className="col-auto">
                    <div className="singleMenu__links row x-gap-30 y-gap-10">
                      <div className="col-auto">
                        <a href="#0" className="text-16 fw-600">
                          {eventDetail?.Display_Name}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-auto">
                    <div className="row x-gap-15 y-gap-15 items-center">
                      <div className="col-auto">
                        <div className="text-14">
                          <span className="mr-5">Onwards</span>
                          <span className="text-22 text-primary fw-600 ml-10">
                            ₹{eventDetail?.Amount}
                          </span>
                        </div>
                      </div>
                      <div className="col-auto">
                        <Link
                          to={`/event-details/${event_id}`}
                          className="button h-50 px-24 -grey-1 bg-primary text-white rounded-25"
                        >
                          Book Now
                          {/* <i className="fas fa-arrow-right ml-15"></i> */}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <section className="pt-20">
            <div className="container">
              <div className="row y-gap-20 justify-between items-end">
                <div className="col-auto">
                  <div className="row x-gap-20  items-center">
                    <div className="col-auto">
                      <h1 className="text-22 sm:text-25 fw-600">
                        {eventDetail?.Display_Name}
                      </h1>
                    </div>
                  </div>
                </div>
                <div className="col-auto">
                  <div className="row x-gap-15 y-gap-15 items-center">
                    <div className="col-auto">
                      <div className="font-inter">
                        {eventDetail?.Amount === "Free" ? (
                          <span className="text-22 text-primary fw-700 ml-5">
                            Free
                          </span>
                        ) : (
                          <>
                            <span className="text-22 text-primary fw-700">
                              ₹ {eventDetail?.Amount}
                            </span>
                            <span className="text-10 fw-400 text-light-1 ml-5">
                              Onwards
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="col-auto">
                      {eventDetail?.Is_Registration_Closed === "Open" ? (
                        <Link
                          to={
                            eventDetail?.Is_External_Event
                              ? eventDetail?.External_Event_Url
                              : `/event-category/${event_id}`
                          }
                          target={
                            eventDetail?.Is_External_Event ? "_blank" : "_self"
                          }
                          rel={
                            eventDetail?.Is_External_Event
                              ? "noopener noreferrer"
                              : undefined
                          }
                          className="button py-10 px-35 -pmdark-1 bg-primary text-16 text-white rounded-25 font-inter"
                        >
                          Book Now
                        </Link>
                      ) : (
                        <button
                          disabled
                          to="#"
                          className="button w-full -sm rounded-25 text-12 px-35 py-10"
                          // className="button py-10 px-35 -pmdark-1 bg-primary text-16 text-white rounded-25 font-inter"
                        >
                          Book Now
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="galleryGrid -type-1 pt-30">
                <div className="galleryGrid__item relative d-flex">
                  <img
                    src={
                      eventDetail?.Image_Path
                        ? `${MEDIA_URL}${eventDetail.Image_Path}`
                        : DefaultEventImg
                    }
                    alt="Banner"
                    className="rounded-16"
                  />
                </div>
                <div className="galleryGrid__item relative">
                  <div className="text-left d-flex items-center pb-10 x-gap-10 font-inter">
                    <i className=" fas fa-calendar text-18 fw-600 text-primary"></i>
                    <div className="text-12 fw-600 lh-1 text-reading">
                      {/* Start Date - {eventDetail?.Start_Date} | End Date -{" "}
                      {eventDetail?.End_Date} */}
                      {dayjs(eventDetail?.Start_Date, "MMM D YYYY").isSame(
                        dayjs(eventDetail?.End_Date),
                        "day"
                      )
                        ? `Event Date - ${eventDetail?.Start_Date}`
                        : `Start Date - ${eventDetail?.Start_Date} | End Date - 
                      ${eventDetail?.End_Date}`}
                    </div>
                  </div>
                  <div className="text-left d-flex items-center py-15 x-gap-10 font-inter">
                    <i className="far fa-clock text-18 fw-600 text-primary"></i>
                    <div className="text-12 fw-600 lh-1 text-reading">
                      {eventDetail?.RaceTime} Onwards
                    </div>
                  </div>
                  <div className="text-left d-flex items-center py-15 x-gap-10 font-inter">
                    <i className="fas fa-map-marker-alt text-18 fw-600 text-primary"></i>
                    <div className="text-12 fw-600 lh-1 text-reading">
                      {eventDetail?.City_Name} , {eventDetail?.State}
                    </div>
                  </div>

                  <div className="text-left d-flex items-center py-15 x-gap-10 font-inter">
                    <i className="fas fa-running text-18 fw-600 text-primary"></i>
                    <div className="text-12 fw-600 lh-1 text-reading">
                      {eventDetail?.EventType_Name}
                    </div>
                  </div>
                  <div
                    className="px-15 lg:px-0 py-20 border-top-light mt-20"
                    style={{ borderTopColor: "#F05736" }}
                  >
                    <h3 className="text-18 fw-500 mb-20">Share Event</h3>
                    <div className="d-flex justify-between mb-15 js-lazy rounded-8">
                      <div
                        className="fas fa-link border-dark-1 text-15 fw-600 rounded-25 px-15 py-15 text-center cursor-pointer h-34 w-34 button -primary-transparent-1"
                        onClick={handlePageShareLink}
                      ></div>
                      <LinkedinShareButton
                        // title={`${eventDetail?.Display_Name}\n`}
                        url={`${window.location.href}`}
                      >
                        <div className="fab fa-linkedin-in border-dark-1 text-15 fw-600 rounded-25 px-15 py-15 text-center cursor-pointer h-34 w-34 button -primary-transparent-1"></div>
                      </LinkedinShareButton>
                      {/* <div className="fab fa-linkedin-in border-dark-1 text-18 fw-600 rounded-25 px-15 py-15 text-center cursor-pointer h-50 w-50 button -primary-transparent-1"></div>
                       */}
                      <FacebookShareButton
                        // title={`${eventDetail?.Display_Name}\n`}
                        url={`${window.location.href}`}
                      >
                        <div className="fab fa-facebook-f border-dark-1 text-15 fw-600 rounded-25 px-15 py-15 text-center cursor-pointer h-34 w-34 button -primary-transparent-1"></div>
                      </FacebookShareButton>
                      <div
                        onClick={() => shareContent()}
                        className="fab fa-instagram border-dark-1 text-15 fw-600 rounded-25 px-15 py-15 text-center cursor-pointer h-34 w-34 button -primary-transparent-1"
                      ></div>
                      <WhatsappShareButton
                        // title={`${eventDetail?.Display_Name}\n`}
                        url={`${window.location.href}`}
                      >
                        <div
                          className="fab fa-whatsapp border-dark-1 text-15 fw-600 rounded-25 px-15 py-15 text-center cursor-pointer h-34 w-34 button -primary-transparent-1"
                          // onClick={handleWhatsappLink}
                        ></div>
                      </WhatsappShareButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="pt-30 layout-pb-md">
            <div className="container">
              <div className="row y-gap-30">
                <div className="col-xl-8">
                  <div className="row y-gap-70">
                    <div id="overview" className="col-12 pb-10 lg:pt-0">
                      <h3 className="text-18 fw-600 pt-20 lg:pt-0">
                        Event Description
                      </h3>
                      <div
                        ref={descriptionRef}
                        className={`text-dark-1 lh-14 text-justify mt-20 font-inter ${
                          !viewMoreDescription && isDescriptionTrimmed
                            ? "trim-3"
                            : ""
                        }`}
                        dangerouslySetInnerHTML={{
                          __html: eventDetail?.Event_Description,
                        }}
                      ></div>
                      {isDescriptionTrimmed && (
                        <p
                          className="text-primary text-13 text-justify cursor-pointer font-inter"
                          style={{ padding: "10px 0 0" }}
                          onClick={() =>
                            setViewMoreDescription(!viewMoreDescription)
                          }
                        >
                          {viewMoreDescription ? "View Less" : "View More"}
                        </p>
                      )}
                    </div>
                    {eligibility?.length > 0 && (
                      <div className="row y-gap-20">
                        <div className="col-xl-12 pt-0 dist-table">
                          <h3 className="text-18 fw-600 pb-20">
                            Event Eligibility
                          </h3>
                          <table className="table-6 border-top-light col-12">
                            <thead className="text-14 fw-600 text-primary border-bottom-light">
                              <tr className="py-10">
                                <th>
                                  <div className="d-flex flex-column gap-10">
                                    <div className="d-flex items-center text-15 fw-600 text-primary">
                                      Race Distance
                                    </div>
                                    <div
                                      className="text-12"
                                      style={{ color: "#fff" }}
                                    >
                                      .
                                    </div>
                                  </div>
                                </th>
                                <th>
                                  <div className="d-flex flex-column gap-10">
                                    <div className="text-15 fw-600 text-primary">
                                      Eligibility Criteria
                                    </div>
                                    <div className="text-12 text-reading fw-500">
                                      ( As on race day )
                                    </div>
                                  </div>
                                </th>
                                <th>
                                  <div className="d-flex flex-column gap-10">
                                    <div className="d-flex items-center text-15 fw-600 text-primary">
                                      Cut Off Time
                                    </div>
                                    <div
                                      className="text-12"
                                      style={{ color: "#fff" }}
                                    >
                                      .
                                    </div>
                                  </div>
                                </th>
                              </tr>
                            </thead>
                            <tbody className="font-inter">
                              {eligibility?.slice(0, 4)?.map((el) => {
                                return (
                                  <tr>
                                    <td className="text-reading">
                                      {el.EventCategory_Name}
                                    </td>
                                    <td className="text-reading">
                                      {el.Eligibility_Criteria}
                                    </td>
                                    <td className="text-reading">
                                      {el.Time_Limit}
                                    </td>
                                  </tr>
                                );
                              })}
                              {eligibilityViewMore &&
                                eligibility?.slice(4)?.map((el) => {
                                  return (
                                    <tr>
                                      <td className="text-reading">
                                        {el.EventCategory_Name}
                                      </td>
                                      <td className="text-reading">
                                        {el.Eligibility_Criteria}
                                      </td>
                                      <td className="text-reading">
                                        {el.Time_Limit}
                                      </td>
                                    </tr>
                                  );
                                })}
                              {eligibility?.length > 4 && (
                                <tr className="w-full">
                                  <td class="text-right">
                                    <div className="d-flex ">
                                      {!eligibilityViewMore ? (
                                        <p
                                          className="text-primary text-13 cursor-pointer font-inter"
                                          onClick={() => {
                                            setEligibilityViewMore(true);
                                          }}
                                        >
                                          View More
                                        </p>
                                      ) : (
                                        <p
                                          className="text-primary text-13 cursor-pointer font-inter"
                                          onClick={() => {
                                            setEligibilityViewMore(false);
                                          }}
                                        >
                                          View Less
                                        </p>
                                      )}
                                    </div>
                                  </td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {priceCategory?.length > 0 && (
                      <div className="row x-gap-20 y-gap-40">
                        <div className="col-xl-12 pt-0 dist-table">
                          <h3 className="text-18 fw-600">Event Prize</h3>
                          {priceCategory?.slice(0, 4).map((price) => {
                            return (
                              <>
                                <div
                                  className={`text-primary fw-500 lh-14 text-justify mt-20 font-inter `}
                                >
                                  {price.EventCategory_Name}
                                </div>
                                <div
                                  className={`text-dark-1 lh-14 text-justify mt-20 font-inter `}
                                  dangerouslySetInnerHTML={{
                                    __html: price?.Event_Prizes,
                                  }}
                                ></div>
                              </>
                            );
                          })}
                          {priceCategory?.length > 4 && (
                            <div className="d-flex w-full">
                              {!priceViewMore ? (
                                <p
                                  className="text-primary text-13 cursor-pointer font-inter"
                                  onClick={() => {
                                    setPriceViewMore(true);
                                  }}
                                >
                                  View More
                                </p>
                              ) : (
                                <p
                                  className="text-primary text-13 cursor-pointer font-inter"
                                  onClick={() => {
                                    setPriceViewMore(false);
                                  }}
                                >
                                  View Less
                                </p>
                              )}
                            </div>
                          )}
                          {/* <table className="table-6 border-top-light col-12">
                            <thead className="text-14 fw-600 text-primary border-bottom-light">
                              <tr className="py-10">
                                <th>Race Distance</th>
                                <th>Gender</th>
                                <th>Age criteria</th>
                                <th>Winner</th>
                                <th className="text-center">1st Runner Up</th>
                                <th className="text-center">2nd Runner Up</th>
                              </tr>
                            </thead>
                            <tbody className="font-inter">
                              {priceCategory?.slice(0, 4)?.map((category) => {
                                console.log(+category.First_Prize);
                                return (
                                  <tr>
                                    <td className="text-reading">
                                      {category.EventCategory_Name}
                                    </td>
                                    <td className="text-reading">
                                      {category.Gender}
                                    </td>
                                    <td className="text-reading">
                                      {category.Age_Group}
                                    </td>
                                    <td className="text-reading">
                                      {!isNaN(+category.First_Prize)
                                        ? `₹ ${category.First_Prize}`
                                        : category.First_Prize}
                                    </td>
                                    <td className="text-reading text-center">
                                      {!isNaN(+category.Second_Prize)
                                        ? `₹ ${category.Second_Prize}`
                                        : category.Second_Prize}
                                    </td>
                                    <td className="text-reading text-center">
                                      {!isNaN(+category.Third_Prize) ===
                                      "number"
                                        ? `₹ ${category.Third_Prize}`
                                        : category.Third_Prize}
                                    </td>
                                  </tr>
                                );
                              })}
                              {priceViewMore &&
                                priceCategory?.slice(4)?.map((category) => {
                                  return (
                                    <tr>
                                      <td className="text-reading">
                                        {category.EventCategory_Name}
                                      </td>
                                      <td className="text-reading">
                                        {category.Gender}
                                      </td>
                                      <td className="text-reading">
                                        {category.Age_Group}
                                      </td>
                                      <td className="text-reading">
                                        {!isNaN(+category.First_Prize)
                                          ? `₹ ${category.First_Prize}`
                                          : category.First_Prize}
                                      </td>
                                      <td className="text-reading text-center">
                                        {!isNaN(+category.Second_Prize)
                                          ? `₹ ${category.Second_Prize}`
                                          : category.Second_Prize}
                                      </td>
                                      <td className="text-reading text-center">
                                        {!isNaN(+category.Third_Prize) ===
                                        "number"
                                          ? `₹ ${category.Third_Prize}`
                                          : category.Third_Prize}
                                      </td>
                                    </tr>
                                  );
                                })}
                              {priceCategory?.length > 4 && (
                                <tr className="w-full">
                                  <td class="text-right">
                                    <div className="d-flex ">
                                      {!priceViewMore ? (
                                        <p
                                          className="text-primary text-13 cursor-pointer font-inter"
                                          onClick={() => {
                                            setPriceViewMore(true);
                                          }}
                                        >
                                          View More
                                        </p>
                                      ) : (
                                        <p
                                          className="text-primary text-13 cursor-pointer font-inter"
                                          onClick={() => {
                                            setPriceViewMore(false);
                                          }}
                                        >
                                          View Less
                                        </p>
                                      )}
                                    </div>
                                  </td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              )}
                            </tbody>
                          </table> */}
                        </div>
                      </div>
                    )}
                    {raceDayFacilities?.length > 0 && (
                      <div className="col-12 pt-0">
                        <h3 className="text-18 fw-600 border-top-light pt-20">
                          Race Day Facilities
                        </h3>
                        <div className="row x-gap-40 y-gap-40 pt-40">
                          <div className="col-xl-12">
                            <div className="row y-gap-30">
                              <div className="col-12">
                                <div className="row">
                                  {raceDayFacilities?.map((facility) => {
                                    return (
                                      <div className="col-lg-4 col-sm-6 d-flex items-center text-13 lg:pb-5 pb-20 font-inter">
                                        <i
                                          className={`${facility?.Icons} text-14 mr-20 text-primary`}
                                        ></i>
                                        {facility?.Facility_Name}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {eventTakeaway?.length > 0 && (
                      <div className="col-12 pt-0">
                        <h3 className="text-18 fw-600 border-top-light pt-20">
                          Race Day Takeaways
                        </h3>
                        <div className="row x-gap-40 y-gap-40 pt-40">
                          <div className="col-xl-12">
                            <div className="row y-gap-30">
                              <div className="col-12">
                                <div className="row">
                                  {eventTakeaway?.map((takeAway) => {
                                    return (
                                      <div className="col-xl-4 col-sm-6 d-flex items-center text-13 mb-10 lg:pb-5 pb-20 font-inter">
                                        <i
                                          className={`${takeAway?.Icons} mr-10 border-primary rounded-22 text-center px-10 py-10 text-primary`}
                                          style={{ background: "#FFFBEE" }}
                                        ></i>
                                        {takeAway?.TakeAway_Name}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {eventDetail?.Refund_Cancellation && (
                      <div className="col-12 pt-0">
                        <h3 className="text-18 fw-600 mb-20 border-top-light pt-20">
                          Refund and Cancellation
                        </h3>
                        <div
                          ref={refundRef}
                          className={`mb-5 text-justify ${
                            !viewMoreRefund && isRefundTrimmed ? "trim-3" : ""
                          }`}
                          dangerouslySetInnerHTML={{
                            __html: eventDetail?.Refund_Cancellation,
                          }}
                        ></div>
                        {isRefundTrimmed && (
                          <p
                            className="text-primary text-justify text-13 cursor-pointer font-inter"
                            onClick={() => setViewMoreRefund(!viewMoreRefund)}
                          >
                            {viewMoreRefund ? "View Less" : "View More"}
                          </p>
                        )}
                      </div>
                    )}
                    {eventDetail?.Rules_Regulations && (
                      <div className="col-12 pt-0">
                        <h3 className="text-18 fw-600 mb-20 border-top-light pt-20">
                          Rules and Regulations
                        </h3>
                        <div
                          ref={rulesRef}
                          className={`mb-5 text-justify ${
                            !viewMoreRules && isRulesTrimmed ? "trim-3" : ""
                          }`}
                          dangerouslySetInnerHTML={{
                            __html: eventDetail?.Rules_Regulations,
                          }}
                        ></div>
                        {isRulesTrimmed && (
                          <p
                            className="text-primary text-justify text-13 cursor-pointer font-inter"
                            onClick={() => setViewMoreRules(!viewMoreRules)}
                          >
                            {viewMoreRules ? "View Less" : "View More"}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-xl-4">
                  <div className="ml-50 lg:ml-0">
                    <div className="px-15 py-15 pl-30 border-light rounded-16 mt-30">
                      <h3 className="text-18 fw-600">Venue</h3>
                      <div className="d-flex mt-10 mb-15 js-lazy">
                        <i className="fas fa-map-marker-alt text-25 text-primary mr-15"></i>
                        <div
                          className="fw-500 lh-14 text-reading font-inter"
                          style={{ fontSize: "12px" }}
                        >
                          {eventDetail?.Event_Venue}
                        </div>
                      </div>
                      <div className="row y-gap-10">
                        <div className="col-12">
                          <a
                            target="_blank"
                            href={`https://www.google.com/maps/search/?api=1&query=${eventDetail?.Event_Venue}`}
                            className="button h-40 w-full px-24 -primary-1 border-primary text-primary rounded-25 font-inter fw-600"
                            rel="noreferrer"
                          >
                            View on map
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="px-15 py-15 pl-30 border-light rounded-16 mt-30">
                      <h3 className="text-16 fw-600 mb-10">Route Map</h3>
                      <div
                        className="flex-center ratio ratio-15:9 mb-15 js-lazy rounded-8 overlay-contain"
                        data-bg="https://img.freepik.com/premium-vector/map-with-destination-location-point-city-map-with-street-river-gps-map-navigator-concept_34645-1078.jpg"
                      >
                        <div className="route-overlay">
                          {eligibility?.map((list, index) => (
                            <>
                              <button
                                key={index}
                                className="px-10 rounded-16 bg-white text-dark-1 text-13"
                                onClick={() => {
                                  setMapImage(list?.Image_Path);
                                  handleOpen();
                                }}
                                // data-x-click="lang"
                              >
                                {list?.EventCategory_Name}
                              </button>
                            </>
                          ))}
                        </div>
                      </div>
                    </div>

                    {bibDetails?.length > 0 && (
                      <div className="px-15 py-15 pl-30 border-primary rounded-16 mt-30">
                        <h3 className="text-18 fw-600">BIB Expo Details</h3>
                        <div className="row mt-10">
                          <div className="col-auto">
                            <h3 className="text-15 fw-600 mb-5 text-primary">
                              Date
                            </h3>
                            {bibDetails?.map((bib) => {
                              return (
                                <p className="text-12 text-reading fw-500 font-inter">
                                  {bib?.BIB_Date}
                                </p>
                              );
                            })}
                          </div>
                          <div className="col-auto">
                            <h3 className="text-15 fw-600 mb-5 text-primary">
                              Time
                            </h3>
                            {bibDetails?.map((bib) => {
                              return (
                                <p className="text-12 text-reading fw-500 font-inter">
                                  {bib?.BIB_StartTime} to {bib?.BIB_EndTime}
                                </p>
                              );
                            })}
                          </div>
                        </div>
                        <div className="mt-10 js-lazy">
                          <h3 className="text-15 fw-600 mb-5 text-primary">
                            BIB Expo Venue
                          </h3>
                          <div className="text-12 text-reading lh-14 fw-500 font-inter">
                            {eventDetail?.BIB_Expo_Venue}
                          </div>
                        </div>
                        <div className="row mt-10">
                          <h3 className="text-15 fw-600 mb-5 text-primary">
                            Instructions
                          </h3>
                          <div className="row">
                            <div className="col-auto">
                              <div className="text-12 text-reading lh-14 fw-500 font-inter">
                                {eventDetail?.BIB_Expo_Comments}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* <div className="px-15 py-15 pl-30 border-light rounded-16 mt-30">
                      <h3 className="text-15 fw-600 mb-5 text-primary">
                        Instructions
                      </h3>
                      <div className="row mt-10">
                        <div className="col-auto">
                          <div className="text-12 text-reading lh-14 fw-500 font-inter">
                            {eventDetail?.BIB_Expo_Comments}
                          </div>
                        </div>
                      </div>
                    </div> */}

                    {reviews?.length > 0 && (
                      <div className="px-15 py-15 pl-30 border-light rounded-16 mt-30">
                        <h3 className="text-18 fw-600">Reviews</h3>
                        <div className="d-flex mt-10 mb-8 js-lazy items-center justify-between border-bottom-light">
                          <div className="d-flex items-center mb-10">
                            <i className="fas fa-star text-20 fw-600 text-green"></i>
                            <div className="text-20 lh-14 ml-10 fw-600">
                              {eventDetail?.Rating}
                            </div>
                          </div>
                          {/* <div class="text-15 lh-14 ml-10 fw-600 mb-10">
                            1K Reviews
                          </div> */}
                        </div>

                        {reviews?.map((rev) => {
                          const stars = [];
                          for (let i = 1; i <= 5; i++) {
                            if (i <= rev.Rating) {
                              stars.push(
                                <i
                                  key={i}
                                  className="fas fa-star text-10 text-primary mr-5"
                                ></i>
                              );
                            } else {
                              stars.push(
                                <i
                                  key={i}
                                  className="fas fa-star text-10 mr-5"
                                  style={{ color: "#FEEFEC" }}
                                ></i>
                              );
                            }
                          }

                          return (
                            <div className="mt-15 mb-15 js-lazy pt-10">
                              <h4 className="text-13 fw-600">
                                {rev.Created_By_Name}
                              </h4>
                              <span className="mr-10 my-1">{stars}</span>
                              <span className="text-12 fw-600  my-1">
                                {dateFormat(rev.Created_On)}
                              </span>
                              <div className="text-12 lh-14 fw-500 text-reading font-inter">
                                {rev.Review}
                              </div>
                            </div>
                          );
                        })}

                        <div className="row y-gap-10">
                          <div className="col-12 d-flex justify-between">
                            <Link
                              to={`/event-reviews/${event_id}/${encryptData(
                                "not_write"
                              )}`}
                              // to="/event-reviews"
                              className="button text-primary fw-600 text-13"
                            >
                              See all reviews
                            </Link>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="layout-pt-md layout-pb-md bg-light-4">
            <div className="container">
              <div className="row y-gap-30 lg:justify-center justify-between items-center">
                <div className="col-lg-6">
                  <div className="row y-gap-20 lg:justify-center flex-wrap lg:flex-column items-center">
                    <div className="col-auto">
                      <div className="flex-center size-100 rounded-full bg-white">
                        {/* <img src={healthIcon} alt="icon" /> */}
                        <Avatar sx={{ bgcolor: "#f05736" }}>
                          {healthSolution?.Organizer_Name?.slice(0, 1)}
                        </Avatar>
                      </div>
                    </div>
                    <div className="col-auto lg:flex-column lg:d-flex lg:items-center lg:justify-center">
                      <h4 className="text-20 text-dark-1 fw-600">
                        {healthSolution?.Organizer_Name}
                      </h4>
                      <div className="text-dark-1 fw-500 text-12 font-inter">
                        Joined on {healthSolution?.Created_On}
                      </div>
                      {/* <div className="text-dark-1 fw-500 text-12 font-inter">
                        Event Organized :{" "}
                        <span className="text-16 fw-600">
                          {healthSolution?.Event_Count}
                        </span>
                      </div> */}
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="single-field -w-410 x-gap-10 y-gap-20">
                    <div className="d-flex flex-column items-center y-gap-20">
                      <p className="text-14 fw-600 font-inter">
                        Have a question?
                      </p>
                      <button
                        onClick={() => {
                          setShowContact(!showContact);
                        }}
                        className="button -md h-40 bg-transparent rounded-22 text-primary border-primary -primary-1 "
                      >
                        {/* cta-btn */}
                        Contact Organizer
                      </button>
                    </div>
                    <div
                      // id="detailsBox"
                      // detailsBox
                      className={`bg-white rounded-8 px-10 py-10 mt-10${
                        showContact ? " d-flex flex-column" : " d-none"
                      }`}
                    >
                      <div className="d-flex items-center mb-5">
                        <i className="fas fa-phone-alt mr-10 text-primary text-12 rounded-22 bg-shadow px-10 py-10"></i>
                        <p className="fw-600 text-13 font-inter">
                          +91 {healthSolution?.Mobile_Number}
                        </p>
                      </div>
                      <div className="d-flex items-center">
                        <i className="fas fa-envelope mr-10 text-primary text-12 rounded-22 bg-shadow px-10 py-10"></i>
                        <p className="fw-600 text-13 font-inter">
                          {healthSolution?.Email_Id}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
}

// const handleWhatsappLink = async () => {
//   try {
//     const url = window.location.href;
//     console.log(url);
//     const message = `Check out this event:\n${url}`;
//     const encodedMessage = encodeURIComponent(message);
//     const whatsappUrl = `https://web.whatsapp.com/send?text=${encodedMessage}`;
//     window.open(whatsappUrl, "_blank");
//   } catch (error) {
//     toast.error("Failed to copy link.");
//   }
// };
// {
/* <div className="col-xl-4">
                        <div className="">
                          <div className="d-flex flex-column">
                            <div className="d-flex items-center text-15 fw-600 text-primary">
                              Race Distance
                            </div>
                            <div className="text-12 text-reading">( Km )</div>
                          </div>
                          <ul className="text-13 fw-500 pt-10 text-light-1">
                            {eligibility?.map((el) => {
                              return (
                                <li className="py-8 text-reading">
                                  {el.EventCategory_Name}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                      <div className="col-xl-4">
                        <div className="">
                          <div className="d-flex flex-column">
                            <div className="text-15 fw-600 text-primary">
                              Eligibility Criteria
                            </div>
                            <div className="text-12 text-reading">
                              ( As on race day )
                            </div>
                          </div>
                          <ul className="text-13 fw-500 pt-10 text-light-1">
                            {eligibility?.map((el) => {
                              return (
                                <li className="py-8 text-reading">
                                  {el.Eligibility_Criteria}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                      <div className="col-xl-4">
                        <div className="">
                          <div className="d-flex flex-column">
                            <div className="d-flex items-center text-15 fw-600 text-primary">
                              Cut Off Time
                            </div>
                            <div className="text-12" style={{ color: "#fff" }}>
                              .
                            </div>
                          </div>
                          <ul className="text-13 fw-500 pt-10 text-light-1">
                            {/* <li className="">60 Mins</li> */
// }
// {
/* {eligibility?.map((el) => {
                              return (
                                <li className="py-8 text-reading">
                                  {el.Time_Limit}
                                </li>
                              );
                            })}
                          </ul> */
// }
